jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  if ($("header.press-hero").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    setTimeout(function () {
      // Highlighter Hero
      setTimeout(() => {
        $(".press-hero .page-title span.blue-bg").addClass("active-highlight");
      }, 1500);
    }, 0);
  }
});
